var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectPath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 47,
    viewBox: "0 0 82 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 20.8749C3.375 20.8749 19.125 40.2499 36 24.2499C47.895 12.9709 33.625 -0.875092 27.25 4.37491C20.751 9.72691 27.563 26.1869 60.125 33.1249",
    stroke: "#23201F",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.193 46.3509C59.696 46.1409 55.879 47.3109 54.636 44.3989C54.074 42.6689 54.781 41.9179 56.231 41.4779C61.409 39.6359 67.113 40.5509 72.314 39.2109C69.891 33.9839 66.182 29.3149 63.316 24.2799C60.455 19.4699 66.774 16.4369 69.283 21.4389C72.955 27.2339 76.681 32.9959 80.301 38.8239C81.785 41.2129 81.446 43.6639 79.541 44.8439C78.704 45.3619 77.63 45.6909 76.644 45.7459C71.83 46.0139 67.01 46.1619 62.193 46.3509Z",
    fill: "#23201F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPath);
export default __webpack_public_path__ + "static/media/project-path.94d8ca63d70bba468f5fb036091af373.svg";
export { ForwardRef as ReactComponent };